export const truncatedTextStyles = {
	endEllipsis: {
		display: 'block',
		minWidth: 0,
		maxWidth: '100%',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap'
	},

	middleRoot: {
		display: 'flex',
		alignItems: 'center',
		gap: 0.5,
		minWidth: 0,
		maxWidth: '100%',
		overflow: 'hidden'
	},

	middleText: {
		minWidth: 0,
		overflow: 'hidden',
		whiteSpace: 'nowrap'
	},

	adornment: {
		flexShrink: 0
	}
};
